import LumaAccessiblePanel from '../admin/CoworkFormPanel';
import {Dialog as LumaAccessibleDialog, DialogTitle as LumaAccessibleTitle} from '@headlessui/react';
import React, { useState } from 'react';
import { X, Trash2 } from 'lucide-react';
import { deletePlanDuracionConfig, PlanDuracionConfig } from '../../services/planconfigService';

interface Props {
    isOpen: boolean;
    config: PlanDuracionConfig | null;
    onClose: () => void;
    onDeleted: (deletedId: number) => void;
}

const DeletePlanConfigModal: React.FC<Props> = ({ isOpen, config, onClose, onDeleted }) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    if (!isOpen || !config) return null;

    const handleDelete = async () => {
        setLoading(true);
        setError(null);
        try {
            await deletePlanDuracionConfig(config.id);
            onDeleted(config.id);
            onClose();
        } catch (err: any) {
            /* Browser diagnostics omitted. */
            setError(err.message || 'Error desconocido');
        } finally {
            setLoading(false);
        }
    };

    return (
        <LumaAccessibleDialog open={isOpen} onClose={onClose} data-luma-overlay="true" className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
            <LumaAccessiblePanel data-luma-dialog="true" className="bg-white p-8 rounded-2xl w-full max-w-md border border-gray-100 shadow-2xl">
                <div className="flex justify-between items-start mb-6">
                    <LumaAccessibleTitle className="text-[20px] font-bold text-gray-900">Confirmar eliminación</LumaAccessibleTitle>
                    <div className="flex items-center gap-4">
                        {error && <div className="text-red-500 text-sm">{error}</div>}
                        <button 
                            onClick={onClose} 
                            className="text-gray-400 hover:text-gray-600 transition-colors"
                            disabled={loading}
                        >
                            <X className="w-6 h-6" />
                        </button>
                    </div>
                </div>

                <p className="mb-8 text-gray-600">
                    ¿Estás seguro que deseas eliminar la configuración del plan{' '}
                    <strong className="text-red-600">{config.plan_nombre}</strong>?
                </p>

                <div className="flex justify-end gap-3 mt-8">
                    <button
                        onClick={onClose}
                        disabled={loading}
                        className="px-5 py-2.5 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors duration-200 font-medium text-[14px]"
                    >
                        Cancelar
                    </button>
                    <button
                        onClick={handleDelete}
                        disabled={loading}
                        className="px-5 py-2.5 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors duration-200 font-medium shadow-sm flex items-center text-[14px]"
                    >
                        <Trash2 className="w-4 h-4 mr-2" />
                        {loading ? 'Eliminando...' : 'Eliminar'}
                    </button>
                </div>
            </LumaAccessiblePanel>
        </LumaAccessibleDialog>
    );
};

export default DeletePlanConfigModal;
